import { LegalContents } from '@chegg-wt/core/types/core'

export const legalContents: LegalContents = {
  commitment: '',
  copyright: '© 2001-2020 EasyBib®, a Chegg service.',
  tagline:
    'We cite according to the 9th edition of MLA, 7th edition of APA, and 16th edition of Chicago (8th edition Turabian).',
}
